export enum SEE_ALL_ROUTES {
  STREAM = 'stream',
  RECOMMENDATIONS = 'recommendations',
  SCHEDULED = 'scheduled',
}
